import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { push } from "connected-react-router";
import { openCloseTourConfirmation, openCloseTour } from "../Global/actions";
import { paths } from "../../config/routes";
import { menuNavigation } from "../Main/actions";
import ilustracion from "../../images/ilustracion1.png";

class TourConfirmationModal extends React.PureComponent {
  handleClose = () => {
    this.props.dispatch(openCloseTourConfirmation(false));
  }

  handleTour = () => {
    this.props.dispatch(push(paths.root));
    this.props.dispatch(menuNavigation({
      isHovering: true,
    }));
    this.props.expandMenu();
    this.props.dispatch(openCloseTour(true));
    this.props.dispatch(openCloseTourConfirmation(false));
  }

  render() {
    return (
      <Popup
        showCloseButton={false}
        visible={this.props.tourConfirmationOpen}
        dragEnabled={false}
        height={420}
        showTitle={false}
        closeOnOutsideClick
        onHiding={this.handleClose}
        width={580}
        contentRender={() => (
          <div>
            <div className="col-12" style={{ justifyContent: "center" }}>
              <div style={{ width: "100%", textAlign: "center" }}>
                <img src={ilustracion} alt="" width="50%" />
                <h3> Bienvenido a ACHS Virtual</h3>
                <div className="modal-tour-confirmation-text">
                  En nuestro nuevo sitio podrás encontrar todo lo que buscas para gestionar tus necesidades como trabajador y como empresa.
                </div>
              </div>
            </div>

            <div className="button-row">
              <div>
                <Button text="Saltar tour" onClick={this.handleClose} />
              </div>

              <div>
                <Button text="Tomar tour" type="success" onClick={this.handleTour} />
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.global.userData,
  tourConfirmationOpen: state.global.tourConfirmationOpen,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TourConfirmationModal);
